<template>
  <div>
    <div class="mt-6">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">อนุมัติรายการเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="grid_tab">
          <v-divider/>
          <v-tabs grow show-arrows color="#86bc3a">
            <v-tab @click="page(0)" style="font-size: 16px">รายการรอตรวจสอบ</v-tab>
            <v-tab @click="page(2)" style="font-size: 16px">ประวัติการตรวจสอบ</v-tab>
          </v-tabs>
          <v-divider/>
        </div>
        <div class="pa-2">
          <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="header" :items="data_list" :footer-props="footer_Props" :items-per-page.sync="item_page" :search="search" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.created_at }}</td>
                  <td class="pa-2">
                    <div class="grid_full mb-2">ชื่อสินค้า : {{ dataDetail.item.product_name }}</div>
                    <div class="grid_half mb-2">
                      <div>รหัสล็อต : {{ dataDetail.item.lot_no }}</div>
                      <div>วันหมดอายุ {{ dataDetail.item.date_expired }}</div>
                    </div>
                    <div class="grid_half mb-2">
                      <div>การย้าย : {{ dataDetail.item.from_warehouse_name }} => {{ dataDetail.item.to_warehouse_name }}</div>
                      <div>จำนวน {{ dataDetail.item.quantity }} {{ dataDetail.item.unit_name }}</div>
                    </div>
                    <div class="grid_full mb-2">
                      <div>สาเหตุ <span class="pl-3">{{ dataDetail.item.cause_note }}</span></div>
                    </div>
                  </td>
                  <td>{{ dataDetail.item.user_name }}</td>
                  <td class="pa-3 text-center">
                    <div v-if="dataDetail.item.status === 0">
                      <v-btn class="pa-6 ma-2 grad-success-bg white--text" @click="open_confirm(dataDetail.item.id)"><v-icon>mdi-check-bold</v-icon> อนุมัติ</v-btn>
                      <v-btn class="pa-6 ma-2 grad-danger-bg-outlined red--text" @click="open_refuse(dataDetail.item.id)"><v-icon>mdi-close-thick</v-icon> ไม่อนุมัติ</v-btn>
                    </div>
                    <div v-if="dataDetail.item.status === 2">
                      <div class="text-center">
                        <div class="primary_color"><v-icon color="#8cc63e" class="mt-n1">mdi-check-bold</v-icon> อนุมัติ</div>
                        <div>{{ dataDetail.item.user_approve_name }} {{ dataDetail.item.updated_at }}</div>
                      </div>
                    </div>
                    <div v-if="dataDetail.item.status === 1">
                      <div class="text-center">
                        <div class="red--text"><v-icon class="red--text mt-n1">mdi-close-thick</v-icon> ไม่อนุมัติ</div>
                        <div>{{ dataDetail.item.user_approve_name }} {{ dataDetail.item.updated_at }}</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card>
      <!-- confirm -->
      <v-dialog v-model="confirm_modal" persistent max-width="700">
        <v-card>
          <div v-if="loading_confirm === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="d-flex justify-space-between">
              <v-card-title>
                ยืนยันการอนุมัติกาารย้ายคลัง
              </v-card-title>
              <v-btn icon class="ma-4" @click="confirm_modal = false">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-card-subtitle>
                <div class="mb-3">คุณแน่ใจใช่ไหมที่ อนุญาติให้การย้ายคลังนี้ดำเนินการ ?</div>
              </v-card-subtitle>
              <div class="text-right mt-8 pb-4">
                <v-btn height="50" class="white--text grad-success-bg mr-2" @click="claim_confirm" type="button">ยืนยัน</v-btn>
                <v-btn height="50" class="white--text grad-danger-bg mr-2" @click="confirm_modal = false" type="button">ยกเลิก</v-btn>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
      <!-- refuse -->
      <v-dialog v-model="refuse_modal" persistent max-width="700">
        <v-card>
          <div v-if="loading_confirm === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="d-flex justify-space-between">
              <v-card-title>
                ยืนยันการไม่อนุมัติกาารย้ายคลัง
              </v-card-title>
              <v-btn icon class="ma-4" @click="refuse_modal = false">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-card-subtitle>
                <div class="mb-3">คุณแน่ใจใช่ไหมที่ ไม่อนุญาติให้การย้ายคลังนี้ดำเนินการ ?</div>
              </v-card-subtitle>
              <div class="text-right mt-8 pb-4">
                <v-btn height="50" class="white--text grad-success-bg mr-2" @click="refuse_confirm" type="button">ยืนยัน</v-btn>
                <v-btn height="50" class="white--text grad-danger-bg mr-2" @click="refuse_modal = false" type="button">ยกเลิก</v-btn>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <v-overlay :value="overlay" class="z_index">
      <div class="text-center">
        <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="#86bc3a"
        ></v-progress-circular>
        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Verify_main",
  data() {
    return {
      loading_page: false,
      loading_confirm: false,
      alert_success: false,
      confirm_modal: false,
      refuse_modal: false,
      overlay: false,
      approve_id: null,
      title: 0,
      search: '',
      item_page: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'วันที่',
          value: '',
          fixed: true,
          sortable: false,
          width: '150px',
        },
        {
          text: 'รายการ',
          value: '',
          fixed: true,
          sortable: false,
          width: '460px',
        },
        {
          text: 'ผู้ดำเนินการ',
          value: '',
          fixed: true,
          sortable: false,
          width: '150px',
        },
        {
          text: 'อนุมัติการดำเนินการ',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '330px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    async page(type) {
      this.title = type
      if (this.title === 0) {
        this.header = [
          {
            text: 'วันที่',
            value: '',
            fixed: true,
            sortable: false,
            width: '150px',
          },
          {
            text: 'รายการ',
            value: '',
            fixed: true,
            sortable: false,
            width: '460px',
          },
          {
            text: 'ผู้ดำเนินการ',
            value: '',
            fixed: true,
            sortable: false,
            width: '150px',
          },
          {
            text: 'อนุมัติการดำเนินการ',
            value: '',
            fixed: true,
            align: 'center',
            sortable: false,
            width: '330px',
          },
        ]
        this.get_data()
      }
      else if (this.title === 2) {
        this.header = [
          {
            text: 'วันที่',
            value: '',
            fixed: true,
            sortable: false,
            width: '150px',
          },
          {
            text: 'รายการ',
            value: '',
            fixed: true,
            sortable: false,
            width: '460px',
          },
          {
            text: 'ผู้ดำเนินการ',
            value: '',
            fixed: true,
            sortable: false,
            width: '150px',
          },
          {
            text: 'อนุมัติการดำเนินการ',
            value: '',
            fixed: true,
            align: 'center',
            sortable: false,
            width: '230px',
          },
        ]
        this.get_data()
      }
    },
    get_data() {
      this.loading_page = true;
      HTTP.post('/inventory/approves/allapprove', {
        status: this.title
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.data_list = res.data.object
        }
      })
    },
    open_confirm(id) {
      this.approve_id = id
      this.confirm_modal = true
    },
    claim_confirm() {
      this.confirm_modal = false
      this.overlay = true
      HTTP.post('/inventory/approves/changestatus', {
        id: this.approve_id,
        status_approve: 2,
        user_approve_id: this.$store.state.userDetail.id,
        user_approve_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.alert_success = true
          setTimeout(() => this.alert_success = false, 2000)
          this.approve_id = null
          this.page(0)
        }
      })
    },
    open_refuse(id) {
      this.approve_id = id
      this.refuse_modal = true
    },
    refuse_confirm() {
      this.refuse_modal = false
      this.overlay = true
      HTTP.post('/inventory/approves/changestatus', {
        id: this.approve_id,
        status_approve: 1,
        user_approve_id: this.$store.state.userDetail.id,
        user_approve_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.alert_success = true
          setTimeout(() => this.alert_success = false, 2000)
          this.approve_id = null
          this.page(0)
        }
      })
    },
  },
  mounted() {
    this.page(0)
  }
}
</script>

<style scoped>
.grid_tab {
  display: grid;
  grid-template-columns: 100%;
  padding: 15px;
}
.grid_full {
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 15px 0;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}
</style>
